import React, {useState} from "react";
import styles from "./popup.module.scss";

const imagePath = "/static-official/images/";
const shownKey = "xiniu_10_year_popup_shown";

export default function IndexPopup() {
  const [visible, setVisible] = useState(() => {
    const hasShown = sessionStorage.getItem(shownKey) === "1";
    sessionStorage.setItem(shownKey, "1");
    return !hasShown;
  });

  if (!visible) {
    return null;
  }

  return (
    <div className={styles.mask}>
      <div className={styles.popup}>
        <picture className={styles.bg}>
          <source srcSet={`${imagePath}popup_xiniu_10_year.webp`} type="image/webp" />
          <img src={`${imagePath}popup_xiniu_10_year.png`} alt="烯牛10周年，AI启新篇" />
        </picture>
        <button className={styles.openBtn} type="button" onClick={() => window.open("https://open.xiniudata.com/", "_blank", "noopener,noreferrer")}>
          <img src={`${imagePath}popup_xiniu_10_year_open.png`} alt="烯牛开放平台" />
        </button>
        <button className={styles.closeBtn} type="button" onClick={() => setVisible(false)} aria-label="关闭">
          <img src={`${imagePath}popup_xiniu_10_year_close.png`} alt="" />
        </button>
      </div>
    </div>
  );
}
